import React, { useState, useEffect } from 'react';
import { trackCustomEvent } from '../../utils/statistics/clientStatistics';
import { trackFavorite } from '../../utils/statistics/customEvents';
import { StyledFavoriteButton } from './FavoriteButton.styles';
import { BUTTON_THEME, BUTTON_TYPE } from '../../ui-components/PlayButton/PlayButton';
import { Experiment, Variant } from '@svt/abtest/lib/redux'; // A/B-test Favorites rollout sep 2021

const FavoriteButton = ({
    titleId,
    isFavorite,
    addFavorite,
    removeFavorite,
    setIsFavorite = () => {},
    setValue = () => {},
    storedValue,
    className,
}) => {
    const [isClient, setIsClient] = useState(false);
    const [triggerAnimation, setTriggerAnimation] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    const handleFavoriteClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setTriggerAnimation(true);

        if (isFavorite) {
            removeFavorite(titleId);
            trackCustomEvent(trackFavorite(titleId, false));
            setIsFavorite(false);

            return;
        }

        addFavorite(titleId);
        trackCustomEvent(trackFavorite(titleId, true));
        setIsFavorite(true);

        if (!storedValue) {
            setValue(true);
        }
    };

    if (!isClient) {
        return (
            <StyledFavoriteButton
                role="button"
                data-rt="my-list-btn"
                buttonType={BUTTON_TYPE.BUTTON}
                isHidden={true}
            >
                Lägg till i Min lista
            </StyledFavoriteButton>
        );
    }

    return (
        <Experiment projectId="svtplay" slug="favorites" defaultVariant="with-favorites" timeout={2000}>
            <Variant slug="without-favorites">
                <></>
            </Variant>
            <Variant slug="with-favorites">
                <StyledFavoriteButton
                    className={className}
                    isFavorite={isFavorite}
                    onClick={handleFavoriteClick}
                    theme={BUTTON_THEME.DEFAULT}
                    buttonType={BUTTON_TYPE.BUTTON}
                    aria-pressed={isFavorite}
                    triggerAnimation={triggerAnimation}
                    role="button"
                    data-rt="my-list-btn"
                >
                    {isFavorite ? 'Ta bort från Min lista' : 'Lägg till i Min lista'}
                </StyledFavoriteButton>
            </Variant>
        </Experiment>
    );
};

export default FavoriteButton;
